module.exports = __webpack_public_path__ + "img/strategy-bg2.481254ca.jpg";